import { render, staticRenderFns } from "./PricePage.vue?vue&type=template&id=4c1039ce&"
import script from "./PricePage.vue?vue&type=script&lang=ts&"
export * from "./PricePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports